import { render, staticRenderFns } from "./ArtistBrowse.vue?vue&type=template&id=674130c0"
import script from "./ArtistBrowse.vue?vue&type=script&lang=ts"
export * from "./ArtistBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports